import { useEffect, useRef } from "react";
import { FiX } from "react-icons/fi";
import { FaInstagram, FaFacebookF } from "react-icons/fa";
import PlaceholderImage from "../common/PlaceholderImage";
import "./TrainerModal.css";

export default function TrainerModal({ trainer, onClose }) {
  const closeRef = useRef(null);

  useEffect(() => {
    closeRef.current?.focus();
    document.body.style.overflow = "hidden";
    const onKeyDown = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [onClose]);

  if (!trainer) return null;

  return (
    <div className="trainer-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="trainer-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="trainer-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button ref={closeRef} type="button" className="trainer-modal__close" onClick={onClose} aria-label="Close trainer profile">
          <FiX aria-hidden="true" />
        </button>
        <div className="trainer-modal__media">
          <PlaceholderImage tone="3" alt={`${trainer.name} profile photo`} ratio="1/1" />
        </div>
        <p className="trainer-modal__specialty">{trainer.specialty}</p>
        <h2 id="trainer-modal-title">{trainer.name}</h2>
        <p className="trainer-modal__meta">{trainer.qualification} · {trainer.experience}</p>
        <p className="trainer-modal__bio">{trainer.bio}</p>
        <div className="trainer-modal__actions">
          <a href="/contact" className="btn btn-primary">Book a Consultation</a>
          <div className="trainer-modal__social">
            <a href={trainer.social.instagram} aria-label={`${trainer.name} on Instagram`}><FaInstagram aria-hidden="true" /></a>
            <a href={trainer.social.facebook} aria-label={`${trainer.name} on Facebook`}><FaFacebookF aria-hidden="true" /></a>
          </div>
        </div>
      </div>
    </div>
  );
}
